import * as Yup from 'yup';

const passengerValidationSchema = ({
  airPassengerInfoFirstNameErrorRequired,
  airPassengerInfoLastNameErrorRequired,
  airPassengerInfoEmailErrorRequired,
}) => [
  Yup.object().shape({
    firstName: Yup.string().required(airPassengerInfoFirstNameErrorRequired),
    lastName: Yup.string().required(airPassengerInfoLastNameErrorRequired),
    email: Yup.string().required(airPassengerInfoEmailErrorRequired),
  }),
  Yup.object().shape({
    firstName: Yup.string().required(airPassengerInfoFirstNameErrorRequired),
    lastName: Yup.string().required(airPassengerInfoLastNameErrorRequired),
  }),
  Yup.object().shape({
    firstName: Yup.string().required(airPassengerInfoFirstNameErrorRequired),
    lastName: Yup.string().required(airPassengerInfoLastNameErrorRequired),
  }),
  Yup.object().shape({
    firstName: Yup.string().required(airPassengerInfoFirstNameErrorRequired),
    lastName: Yup.string().required(airPassengerInfoLastNameErrorRequired),
  }),
];

export default passengerValidationSchema;
